import { useLocation } from 'react-router-dom';

import { QUERY_PARAMS } from '../constants';

const useCommerceQueryParams = () => {
  const location = useLocation().search;
  const params = new URLSearchParams(location);

  return [params.get(QUERY_PARAMS.STORE), params.get(QUERY_PARAMS.DISPATCH_METHOD)];
};

export default useCommerceQueryParams;
